export function objectValues(object) {
    const values = []
    for(var key in object) {
      values.push(object[key])
    }
    return values
  }


function formatIndicator(indicator) {
    return '<li class="indicator">' + indicator + '</li>'
}

function formatIndicators(indicators) {
    return '<tr><td class="section-header"><h4 class="text-header">DEVELOPMENT ASSESSMENT CENTER</h4></td></tr>'
        + '<tr><td class="sub-header"><h4 class="text-header">A.	Behavioral Observations from Structured Learning Exercises</h4></td></tr>'
        + '<tr><td class="body-header"><br/>The following behaviors were displayed:<ul>' + objectValues(indicators).map(indicator => formatIndicator(indicator)  ).join('') + '</ul></td></tr>'
}

function formatCp(cp) {
    return '<table style="border: 1px solid; border-collapse: collapse; border-spacing: 0; width: 100%">' 
    + '<tbody><tr><td style="border: 1px solid; padding: 20px; text-align: center;"><h3 class="cp-header">'+ cp.name + '</h3></td>'
     + '<tr><td class="section-header"><h4 class="text-header">HATS ONLINE RESULTS</h4></td></tr>'
    + '<tr><td><br/>&nbsp;<br/>&nbsp;</td></tr>'
    + formatIndicators(cp.answers)
    + '<tr><td class="sub-header"><h4 class="text-header">B.	Interview</h4></td></tr>'
    + '<tr><td><br/>&nbsp;<br/>&nbsp;</td></tr>'
    + '</tbody></table><br />'
}



export default function formatReport(data) {
    const style = '<style>'
        + '.cp-header { font-family: Arial; font-weight: bold;font-size: 12pt;color: #696969; text-transform: capitalize }'
        + '.section-header {  border: 1px solid black; background: #DF7A00; color:white; text-align: center }'
        + '.indicator { font-family: Arial; font-size: 10pt; color: black }'
        + '.text-header {font-family: Arial; font-size: 10pt; font-weigh: bold}'
        + '.body-header { padding-left: 1em; font-family: Arial; font-size: 10pt; color: black }'
        + '.sub-header {border: 1px solid black; background: #d0d0d0; text-align: center}'
        + '</style>'
    return style + objectValues(data).map(cp => formatCp(cp)  ).join('')
}


// WEBPACK FOOTER //
// ./src/modules/competencies/utils/format-report-jfc.js